import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {Helmet} from 'react-helmet';
import { map, sumBy, capitalize } from 'lodash';
import { Link } from 'react-router-dom';
import Spinner from '../../components/common/Spinner';
import ConfirmClick from '../../components/common/ConfirmClick';
import StatementPeriodDates from '../../components/pages/imports/StatementPeriodDates';
import ReactTable from 'react-table';
import selectTableHOC from "react-table/lib/hoc/selectTable";
import { importsActions } from '../../data/actions/imports';
import CSV from '../../helpers/CSVExport';

var downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');

class PaidReports extends Component {
	constructor(props) {
		super(props);
		this.state = {
			period: null,
			undone: false,
		};
		this.exportToCsv = this.exportToCsv.bind(this);
		this.undoImport = this.undoImport.bind(this);
		this._columnsCache = null;
		this._columnsCacheKey = null;
	}

	componentDidMount() {
		const { period, accepted } = this.props;
		this.props.dispatch(importsActions.getPaidReports(period, accepted));
		this.setState({ period });
	}

	componentDidUpdate(prevProps) {
		const { period, accepted } = this.props;
		if (period !== prevProps.period || accepted !== prevProps.accepted) {
			this.props.dispatch(importsActions.getPaidReports(period, accepted));
			this.setState({ period, undone: false });
		}
	}

	undoImport() {
		const { period } = this.props;
		this.props.dispatch(importsActions.getAuditReports()).then(entries => {
			const entry = (entries || []).find(e => e.report_date == period);
			return this.props.dispatch(importsActions.rejectSalesData(period, entry && entry.id));
		}).then(()=> {
			this.setState({ undone: true });
			return this.props.dispatch(importsActions.getPaidReports(period, false));
		});
	}

	exportToCsv() {
		const { period } = this.state;
		let { reports } = this.props.imports;
		const filename = CSV.CSVHeader('paid_reports', period);
		return CSV.CSVExport(reports.data, { filename }, 'paid_reports');
	}

	getColumnHeader(key, array) {
		let completedCount = 0;
		let otherCount = 0;

		for (let i = 0; i < array.length; i++) {
			const status = array[i][`${key}_status`];
			if (status === 'COMPLETED') {
				completedCount++;
			} else if (status !== null && status !== '') {
				otherCount++;
			}
		}
		return `${capitalize(key)} - (${completedCount} / ${otherCount})`;
	}

	// Checkbox filter: unchecked = show all, checked = only non-null & not COMPLETED
	getStatusFilter = ({ filter, onChange }) => {
		const checked = filter && filter.value === true;
		return (
			<label>
				<input
					type="checkbox"
					checked={!!checked}
					onChange={e => onChange(e.target.checked ? true : undefined)}
				/>
				<span style={{ fontSize: 11 }}>Errors</span>
			</label>
		);
	};

	getStatusFilterMethod = (filter, row) => {
		if (!filter || filter.value !== true) return true;
		const status = row['_original'][`${filter.id}_status`];
		// Show only rows where status is present and not COMPLETED
		return status != null && status !== '' && status !== 'COMPLETED';
	};

	buildColumns(columnKeys, data) {
		// Status counts can change between selections with the same row count.
		const cacheKey = columnKeys.join('|');
		if (this._columnsCache && this._columnsCacheKey === cacheKey && this._columnsCacheData === data) {
			return this._columnsCache;
		}

		const statusColumns = columnKeys.map(key => ({
			id: key,
			accessor: key,
			Header: this.getColumnHeader(key, data),
			filterable: true,
			Filter: this.getStatusFilter,
			filterMethod: this.getStatusFilterMethod,
			Cell: ({ original }) => (
				<span className="import-status">
					{original[`${key}_status`]}
					{original[`${key}_rows_loaded`] && (
						<span className="import-status-count">
							{original[`${key}_rows_loaded`]}
						</span>
					)}
					{original[`${key}_error_message`] && (
						<span
							className="import-status-error"
							title={original[`${key}_error_message`]}
						>
							<i className="fa fa-exclamation-triangle" />
						</span>
					)}
				</span>
			),
		}));

		const columns = [
			{
				id: 'source_label',
				accessor: 'source_label',
				Header: 'Label',
				className: 'table-text-left name-cell',
				headerClassName: 'table-text-left',
				filterable: true,
			},
			...statusColumns,
		];

		this._columnsCache = columns;
		this._columnsCacheKey = cacheKey;
		this._columnsCacheData = data;
		return columns;
	}

	render() {
		const { reportsLoading, reports = {} } = this.props.imports;
		const { accepted, period } = this.props;
		const { undone } = this.state;
		const { columns: columnKeys = [], data = [] } = reports;

		const columns =
			columnKeys.length > 0 ? this.buildColumns(columnKeys, data) : [];

		return (
			<div className="inner-page shared-pages">
				<div className="container">
					<h2>
						Paid Reports
						<a
							title="Export"
							onClick={() => this.exportToCsv()}
							className="chart-icon download-link"
							dangerouslySetInnerHTML={{ __html: downloadSvg }}
						/>
						{accepted && !undone && <span>Period already imported!</span>}
						{accepted && !undone && <ConfirmClick confirmAction={this.undoImport} title="Undo import" confirmClass="btn btn-primary" confirmLabel={'Undo import'} confirmPrompt={`Are you sure you want to undo the import for ${period}?`} />}
					</h2>
					<div className="ibox">
						<ReactTable
							data={data}
							loading={reportsLoading}
							columns={columns}
							filterable={true}
							showPagination={data.length > 10}
							className="simple-table share-table"
							defaultFilterMethod={(filter, row) =>
								String(row[filter.id] || '').match(
									new RegExp(filter.value, 'i')
								)
							}
						/>
					</div>
				</div>
				<Helmet>
					<title>Pending reports</title>
				</Helmet>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		imports: state.imports,
	};
}

export default connect(mapStateToProps)(PaidReports);